/**
 * The Report's per-category capability overview (docs/event-model.md §7).
 * Owned by Phase 4 lane C.
 */
import { type AuditEvent, maxSeverity } from "../events";
import { originOf } from "../url";
import type { CapabilitySummary, CategorySummary } from "./types";

const addOnce = (list: string[], item: string) => {
  if (!list.includes(item)) list.push(item);
};

/** Counts, highest severity, targets, and network origins per category, in first-seen order. */
export function summarizeCapabilities(events: readonly AuditEvent[]): CapabilitySummary {
  const summary: CapabilitySummary = {};
  for (const event of events) {
    const entry: CategorySummary = summary[event.category] ?? {
      count: 0,
      severity: "info",
      targets: [],
      origins: [],
    };
    entry.count++;
    entry.severity = maxSeverity(entry.severity, event.severity);
    addOnce(entry.targets, event.target);
    const origin = event.network ? originOf(event.network.url) : "null";
    if (origin !== "null") addOnce(entry.origins, origin);
    summary[event.category] = entry;
  }
  return summary;
}
